import React from 'react';
import {
  Briefcase,
  Calendar,
  Handshake,
  Home,
  Package,
  Tag,
  Truck,
  Users,
  Wrench,
} from 'lucide-react';

const iconMap = {
  Tag,
  Wrench,
  Truck,
  Package,
  Handshake,
  Home,
  Briefcase,
  Calendar,
  Users,
};

export const CategoryIcon = ({ name, size = 16, className }) => {
  const Icon = iconMap[name] || Tag;
  return <Icon size={size} className={className} aria-hidden="true" />;
};

export default CategoryIcon;
